import { I18n } from '@calendly/i18n';
import { ArrowRightIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useRightRail } from 'features/right_rail';
import { SETTINGS_SECTION } from 'features/settings_modal/constants';
import { getSettingsNavigationLinkProps, useSettingsNavigation } from 'features/settings_modal/use_settings_navigation';
import { isSidebarOpenSelector } from 'features/sidebar_placeholder';
import { useIsUserGuideExpanded } from 'features/user_guide';
import { Section } from './components/section';
import { EventData } from './sections/event_data';
import { Recommended } from './sections/recommended';
import { Users } from './sections/users';
const contentContainerIsCompactCss = "c6rddi";
const contentContainerCss = "c1k1dr09";
const ContentContainer = forwardRef((props, ref) => {
  const {
    isCompact,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentContainerCss, {
    [contentContainerIsCompactCss]: isCompact
  }, props.className)} />;
});
const styledContainerIsTabletDownCss = "s12mjbp1";
const styledContainerCss = "sx9lob3";
const StyledContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletDown = useDeviceType('isTabletDown');
  return <Component ref={ref} {...restProps} className={classNames(styledContainerCss, {
    [styledContainerIsTabletDownCss]: isTabletDown
  }, props.className)} />;
});
const userContainerCss = "u13kb5ep";
const UserContainer = forwardRef((props, ref) => <StyledContainer ref={ref} {...props} className={classNames(userContainerCss, props.className)} />);
const eventDataContainerCss = "eucoh3";
const EventDataContainer = forwardRef((props, ref) => <StyledContainer ref={ref} {...props} className={classNames(eventDataContainerCss, props.className)} />);
const recommendedContainerIsCompactCss = "r1hafckh";
const recommendedContainerIsTabletDownCss = "re7ztuv";
const recommendedContainerCss = "r152eict";
const RecommendedContainer = forwardRef((props, ref) => {
  const {
    isCompact,
    ...restProps
  } = props;
  const isTabletDown = useDeviceType('isTabletDown');
  return <StyledContainer ref={ref} {...restProps} className={classNames(recommendedContainerCss, {
    [recommendedContainerIsCompactCss]: isCompact,
    [recommendedContainerIsTabletDownCss]: isTabletDown
  }, props.className)} />;
});
const arrowLinkCss = "a1lbqzj4";
const ArrowLink = forwardRef(({
  openInNewTab = true,
  ...props
}, ref) => {
  const target = openInNewTab ? '_blank' : undefined;
  const rel = openInNewTab ? 'noopener noreferrer' : undefined;
  const underline = false;
  return <Link ref={ref} {...props} target={target} rel={rel} underline={underline} className={classNames(arrowLinkCss, props.className)} />;
});
export const Content = () => {
  const isSidebarOpen = useSelector(isSidebarOpenSelector);
  const isUserGuideExpanded = useIsUserGuideExpanded();
  const {
    isOpen: isRightRailOpen
  } = useRightRail();
  const {
    hrefForSettingsSection,
    navigateToSettingsSection
  } = useSettingsNavigation();
  const rightSidebarExpanded = isRightRailOpen || isSidebarOpen || isUserGuideExpanded;
  const teamSettingsTarget = hrefForSettingsSection(SETTINGS_SECTION.adminPeople, '/app/admin/users', 'active_users');
  const teamSettingsLinkProps = getSettingsNavigationLinkProps({
    target: teamSettingsTarget,
    navigate: () => navigateToSettingsSection(SETTINGS_SECTION.adminPeople, {
      legacyPath: '/app/admin/users',
      settingsTab: 'active_users'
    })
  });
  return <ContentContainer isCompact={rightSidebarExpanded}>
      <UserContainer data-component="user-stats">
        <Section name={I18n.t('publisher.admin.dashboard.section.users.title')} controls={<ArrowLink {...teamSettingsLinkProps} openInNewTab={false}>
              {I18n.t('publisher.admin.dashboard.section.users.link.view_team')}
              <ArrowRightIcon />
            </ArrowLink>}>
          <Users />
        </Section>
      </UserContainer>
      <RecommendedContainer isCompact={rightSidebarExpanded}>
        <Section name={I18n.t('publisher.admin.dashboard.section.recommended.title')}>
          <Recommended />
        </Section>
      </RecommendedContainer>
      <EventDataContainer data-component="event-data">
        <Section name={I18n.t('publisher.admin.dashboard.section.event_data.title')} controls={<ArrowLink href="/app/organization/reporting">
              {I18n.t('publisher.admin.dashboard.section.event_data.link.view_analytics')}
              <ArrowRightIcon />
            </ArrowLink>}>
          <EventData />
        </Section>
      </EventDataContainer>
    </ContentContainer>;
};

require("./content.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./content.js");